<template>
  <div class="PageChildRoot">
    <router-view v-if="child" :child="child" />
    <p v-else>...</p>
  </div>
</template>

<script>
export default {
  name: 'PageChildRoot',
  layout: 'app',
  props: {
    child: {},
  },
}
</script>

<style scoped lang="scss">
.PageChildRoot {}
</style>
